export const STAFF_SECTIONS = [
  { key: 'harvesting', label: 'Harvesting - collection and support', description: 'Set up collection questions, help participants and record phone reports.' },
  { key: 'stewardship', label: 'Stewardship - evidence and guidance', description: 'Review evidence, manage species and publish species-area guidance. Community admins manage source map datasets.' },
  { key: 'consultation', label: 'Consultation', description: 'Manage consultation forms and community responses.' },
  { key: 'landValues', label: 'Land values', description: 'Manage community criteria and land-value scoring.' },
  { key: 'communityData', label: 'Community data', description: 'Manage community statistics and consent-controlled exports.' },
  { key: 'landUnits', label: 'Land units', description: 'Manage land-unit assessments and supporting evidence.' },
  { key: 'communityNews', label: 'Community news', description: 'Create and manage community news.' },
];

export function canStaffSection(user, tenantId, section) {
  if (['cip_admin', 'cip_staff'].includes(user?.globalRole)) return true;
  return !!tenantId && !!user?.access?.staffSectionsByTenant?.[String(tenantId)]?.includes(section);
}

export function showDepartmentNavigation(user, tenantId, communityRole, section) {
  return communityRole !== 'community_staff' || canStaffSection(user, tenantId, section);
}
